import type { BadgeTone } from '@/components/ui'
import type { components } from '@/lib/client'
import { Badge } from '@/components/ui'

type User = components['schemas']['User']

const ROLE_TONE: Record<string, BadgeTone> = {
  admin: 'gold',
  'super-admin': 'plum',
  standard: 'emerald',
}

export default function AdminUsers({ users }: { users: Array<User> }) {
  return (
    <div className="oumma-table-wrap">
      <table className="oumma-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Rôle</th>
            <th>Source</th>
            <th>Créé le</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.email}</td>
              <td>
                <Badge tone={ROLE_TONE[user.role] ?? 'emerald'}>
                  {user.role}
                </Badge>
              </td>
              <td>{user.provider}</td>
              <td>{new Date(user.creation_time).toLocaleString('fr-FR')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
